import { Component } from '@angular/core';

@Component({
    selector: 'app-second-menu',
    templateUrl: './second-menu.component.html',
    styleUrls: ['./second-menu.component.css'],
    standalone: false
})
export class SecondMenuComponent {

}